import React from 'react';
import {Route, Switch} from "react-router";
import {LINK} from "./utils/Links";
import RootPageContainer from "./page/root/RootPageContainer";
import HomePageContainer from "./page/home/HomePageContainer";
import SignInContainer from "./page/signin/SignInContainer";
import {AuthorizedRoute} from "./security/AuthorizedRoute";

const App = () => {

    return <Switch>
        <Route exact path={LINK.ROOT} component={RootPageContainer}/>
        <AuthorizedRoute exact path={LINK.HOME} component={HomePageContainer}/>
        <Route exact path={LINK.SIGNIN} component={SignInContainer}/>
    </Switch>
};

export default App;
